export default __webpack_public_path__ + "content/media/1.eade0d41.jpg";